import barba from '@barba/core';
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.aquacultureContent()
			this.processContent()
			this.aboutContent()
			this.interlude()
			this.historyWrapper()
        })
        barba.hooks.after((data) => {
            this.aquacultureContent()
			this.processContent()
			this.aboutContent()
			this.interlude()
			this.historyWrapper()
        });
    }
    aquacultureContent() {
		const wrapper = document.querySelector('.c-business-flow.--aquaculture .c-business-flow__content--wrapper');
		const content = document.querySelector('.c-business-flow');
		if (wrapper) {
			ScrollTrigger.matchMedia({
				"(min-width: 992px)": function() {
					const content = gsap.utils.toArray('.c-business-flow__content');
					const wrapperWidth = wrapper.offsetWidth;
					gsap.to(content, {
						xPercent: -100 * (content.length - 1),
						ease: "none",
						scrollTrigger: {
							trigger: wrapper,
							pin: true,
							scrub: 1,
							end: () => "+=" + wrapperWidth,
							onUpdate: self => {
								const progress = (self.progress.toFixed(2) * 100).toFixed(0);
								const indicator = document.querySelector('.progress__indicator');
								if (indicator) {
									indicator.style.width = progress + '%';
									const currentIndex = Math.floor(content.length * self.progress);
									if (progress >= 99.9) {
										indicator.dataset.current = 3;
									} else if (progress >= 66.6) {
										indicator.dataset.current = 2;
									} else if (progress >= 33.3) {
										indicator.dataset.current = 1;
									} else {
										indicator.dataset.current = 0;
									}
								}			  
							}
						}
					});
				},
				"(max-width: 991px)": function() {
					const wrapper = document.querySelector('.c-business-flow.--aquaculture .c-business-flow__content--wrapper');
					const indicator = document.querySelector('.progress__indicator');
					if (wrapper && indicator) {
						ScrollTrigger.create({
							trigger: wrapper,
							start: 'top top',
							end: 'bottom bottom',
							onUpdate: (self) => {
								const progress = self.progress.toFixed(2) * 100;
								indicator.style.height = `${progress}%`;
								if (progress >= 99.9) {
									indicator.dataset.current = 3;
								} else if (progress >= 66.6) {
									indicator.dataset.current = 2;
								} else if (progress >= 33.3) {
									indicator.dataset.current = 1;
								} else {
									indicator.dataset.current = 0;
								}
							}
						});
					}
				}
			});
		}

		if (content) {
			const contentElement = content;
			window.addEventListener('scroll', function() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				var windowHeight = window.innerHeight;
				var contentTop = contentElement.offsetTop;
				var contentHeight = contentElement.offsetHeight;
				var contentBottom = contentTop + contentHeight;
				if (scrollTop >= contentTop && scrollTop + windowHeight <= contentBottom) {
					contentElement.classList.add('is-inview');
				} else {
					contentElement.classList.remove('is-inview');
				}
			});
		}
	}
	processContent() {
		const wrapper = document.querySelector('.c-business-flow.--process .c-business-flow__content--wrapper');
		const content = document.querySelector('.c-business-flow');
		if (wrapper) {
			ScrollTrigger.matchMedia({
				"(min-width: 992px)": function() {
					const content = gsap.utils.toArray('.c-business-flow__content');
					const wrapperWidth = wrapper.offsetWidth;
					gsap.to(content, {
						xPercent: -100 * (content.length - 1),
						ease: "none",
						scrollTrigger: {
							trigger: wrapper,
							pin: true,
							scrub: 1,
							end: () => "+=" + wrapperWidth,
							onUpdate: self => {
								const progress = (self.progress.toFixed(2) * 100).toFixed(0);
								const indicator = document.querySelector('.progress__indicator');
								if (indicator) {
									indicator.style.width = progress + '%';
									const currentIndex = Math.floor(content.length * self.progress);
									if (progress >= 99.9) {
										indicator.dataset.current = 4;
									} else if (progress >= 75) {
										indicator.dataset.current = 3;
									} else if (progress >= 50) {
										indicator.dataset.current = 2;
									} else if (progress >= 25) {
										indicator.dataset.current = 1;
									} else {
										indicator.dataset.current = 0;
									}
								}			  
							}
						}
					});
				},
				"(max-width: 991px)": function() {
					const wrapper = document.querySelector('.c-business-flow.--process .c-business-flow__content--wrapper');
					const indicator = document.querySelector('.progress__indicator');
					if (wrapper && indicator) {
						ScrollTrigger.create({
							trigger: wrapper,
							start: 'top top',
							end: 'bottom bottom',
							onUpdate: (self) => {
								const progress = self.progress.toFixed(2) * 100;
								indicator.style.height = `${progress}%`;
								if (progress >= 99.9) {
									indicator.dataset.current = 4;
								} else if (progress >= 75) {
									indicator.dataset.current = 3;
								} else if (progress >= 50) {
									indicator.dataset.current = 2;
								} else if (progress >= 25) {
									indicator.dataset.current = 1;
								} else {
									indicator.dataset.current = 0;
								}
							}
						});
					}
				}
			});
		}

		if (content) {
			const contentElement = content;
			window.addEventListener('scroll', function() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				var windowHeight = window.innerHeight;
				var contentTop = contentElement.offsetTop;
				var contentHeight = contentElement.offsetHeight;
				var contentBottom = contentTop + contentHeight;
				if (scrollTop >= contentTop && scrollTop + windowHeight <= contentBottom) {
					contentElement.classList.add('is-inview');
				} else {
					contentElement.classList.remove('is-inview');
				}
			});


		}
	}
	aboutContent() {

		const aboutDetails = document.querySelector(".p-about__details");
        const aboutImgs = document.querySelectorAll(".p-about__detail .p-about__img");
        const aboutContents = document.querySelectorAll(".p-about__detail .p-about__detail--inner");
        
        if (aboutDetails) {
			//console.log(aboutDetails)
            for (let i = 0; i < aboutImgs.length; i++) {
                const aboutImg = aboutImgs[i];
                const aboutContent = aboutContents[i];
				//console.log(aboutImg)
				ScrollTrigger.create({
					trigger: aboutImg,
					pin: true,
					start: 'top top',
					endTrigger: aboutContent,
					end: 'bottom bottom',
					//markers: true,
				});
            }
        }
	}
	interlude() {
		const inteludeContent = document.querySelector(".js-parallax__wrapper");
        if (inteludeContent) {
			//console.log(inteludeContent)
            gsap.utils.toArray('.js-parallax').forEach(wrap => {
				const y = wrap.getAttribute('data-y') || -100;
				gsap.to(wrap, {
					y: y,
					scrollTrigger: {
						trigger: wrap,
						start: 'top bottom',
						end: 'bottom top',
						scrub: 0.5,
					}
				})
			});
        }
	}
	toggleHistoryWrapper(target) {
        const wrapper = document.querySelector(`.p-history__wrapper--inner[data-target="${target}"]`);
        const checkbox = document.querySelector(`.p-history__wrapper--trigger[data-target="${target}"] input[type="checkbox"]`);
        
        if (checkbox.checked) {
            wrapper.classList.add('expanded');
        } else {
            wrapper.classList.remove('expanded');
        }
    }
    historyWrapper() {
        const historyContent = document.querySelector(".p-history.--jp");
        if (historyContent) {
            // チェックボックスの変更イベントを監視してクラスをトグル
            const checkboxes = document.querySelectorAll('.p-history__wrapper--trigger input[type="checkbox"]');
            checkboxes.forEach((checkbox) => {
                checkbox.addEventListener('change', () => {
                    const target = checkbox.closest('.p-history__wrapper--trigger').getAttribute('data-target');
                    this.toggleHistoryWrapper(target); // クラスのメソッドとして呼び出す
                });
            });
        }
    }
}